import { Directive } from '@angular/core';

@Directive({
    selector: '[luiLayoutDualColMain]',
    standalone: false
})
export class LayoutDualColMainDirective {}

@Directive({
    selector: '[luiLayoutDualColAside]',
    standalone: false
})
export class LayoutDualColAsideDirective {}

@Directive({
    selector: '[luiLayoutDualColShared]',
    standalone: false
})
export class LayoutDualColSharedDirective {}

@Directive({
    selector: '[luiLayoutDualColDrawerContent]',
    standalone: false
})
export class LayoutDualColDrawerContentDirective {}
